var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', _vm._b({}, 'sub-visual', _vm.visual, false)), _c('div', {
    staticClass: "client-content-wrap pb-0"
  }, [_c('section', {
    staticClass: "client-section pb-0"
  }, [_c('v-container', [_c('business-intro', _vm._b({}, 'business-intro', _vm.intro, false))], 1)], 1)]), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('scrolldown-tail'), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/business/domestic/middle/process-list.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-row', {
    staticClass: "process-list row--lg"
  }, _vm._l(_vm.process, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "process-card",
      attrs: {
        "color": "#FAFAFA",
        "flat": ""
      }
    }, [_c('v-row', {
      staticClass: "text-center"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-img', {
      staticClass: "mb-24 mx-auto",
      attrs: {
        "src": `/images/business/domestic/middle/process-${index + 1}.svg`,
        "max-width": "80"
      }
    }), _c('div', {
      staticClass: "tit tit--sm primary--text mt-16",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _c('div', {
      staticClass: "page-text page-text--lg mt-16",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)], 1)], 1)], 1);
  }), 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("주요 프로그램")])]), _c('program-list', {
    attrs: {
      "items": _vm.programs
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }